export default __webpack_public_path__ + "static/media/pin.0405a3f2.svg";